import { styled } from '@mui/material';
import { ReactNode } from 'react';

type IconSvgProps = {
  children: ReactNode;
};

export const IconSvg = ({ children }: IconSvgProps) => (
  <StyledIcon>{children}</StyledIcon>
);

const StyledIcon = styled('div')(() => ({
  display: 'inline-block',
  width: '1em',
  height: '1em',
  color: 'inherit',
}));
